import React from 'react';

export const Loader = (props) => <span>
    <img src="/upload/custom/loader2.gif" {...props} width="40" height="40" alt=""/>
</span>;